import Web3 from 'web3'
import { useContext } from 'react';
import ConnectedContext from '../../context/connectedcontext';
import ModalVisibilityContext from '../../context/modalvisiblitycontext';
import Web3Context from '../../context/web3context';
// import Web3ProviderContext from '../../context/web3ProviderContext';
import Web3ContractReadWriteContext from '../../context/web3ContractReadWriteContext';
import { getScratchBalance } from '../utils/scratch-functions';
import { providers } from './providers';
import { webStorage } from '../../config';



function MetamaskButton() {

    // //web 3 provider
    // const {web3Provider, setWeb3Provider} = useContext(Web3ProviderContext)

    //set up for web3 and account context
    const { setAccount, setBalance, setChainID, setScratchBalance } = useContext(Web3Context)

    //set up for connected logic context
    const { setConnected } = useContext(ConnectedContext)

    //set up for Modal Visibility Context
    const { setModalVisibility } = useContext(ModalVisibilityContext)

    // set up contract read and write providers
    const { setContractReadProviders, setContractWriteProviders } = useContext(Web3ContractReadWriteContext)


    //called when pressing on the metamask button inside the connect modal
    function Connect() {

        //initialize web3
        const web3temp = new Web3(Web3.givenProvider || "ws://localhost:8545");

        //set and propagate web3 through the entire app
        // setWeb3(web3temp)


        //ask for access from metamask
        web3temp.eth.requestAccounts().then(function (accounts) {
            const account = accounts[0]
            // setWeb3Provider(null)


            // set contract read and write
            setContractReadProviders(providers.readProvider || Web3.givenProvider || "ws://localhost:8545")
            setContractWriteProviders(Web3.givenProvider || "ws://localhost:8545")

            //set and propagate account
            setAccount(account)
            //web3temp.eth.getBalance(accounts[0], function(err, result) {
            web3temp.eth.getBalance(accounts[0], function (err, result) {
                if (err) {
                    console.log(err)
                } else {
                    console.log(web3temp.utils.fromWei(result, "ether") + " ETH")
                    setBalance(web3temp.utils.fromWei(result, "ether"))
                }
            })
            web3temp.eth.getChainId().then(function (result: any) {
                setChainID(result)
                console.log(result)
            })
            getScratchBalance(Web3.givenProvider || "ws://localhost:8545", accounts[0]).then(function (scratchResult) {
                setScratchBalance(scratchResult as string)
                console.log('Scratch balance:', scratchResult)

            }).then(function () {
                setConnected(true)
                localStorage.setItem('isWalletConnected', 'true')
                setModalVisibility(false)

            })
        });

    }
    return (
        <button
            type="button"
            className="flex w-full items-center justify-between gap-3 rounded-[20px] border border-white/10 bg-white/5 px-4 py-4 text-left text-sm font-semibold uppercase tracking-[0.14em] text-[#f6efd3] transition hover:border-[#59d6ff]/35 hover:bg-[#59d6ff]/10"
            onClick={Connect}
        >
            <span>Metamask</span>
            <img
                className="h-8 w-8 rounded-xl bg-white/8 p-1 object-contain"
                src={webStorage + '/navbar/metamasklogo.png'}
                alt="Metamask"
            />
        </button>
    )
}
export default MetamaskButton
